// FILE: src/hooks/useCurriculum.js
// The curriculum version the student is fixed to (WP-5; MTO Preface, matrix
// 0.7): GET /api/resources/curriculum → { curriculum: { id, name, version,
// status, mtoApprovalRef, approvedAt } | null }. Null while loading, when the
// student has none (content from before curricula) or when it can't load;
// pages then simply leave the line out.
import { useEffect, useState } from "react";
import fetchWithAuth from "../utils/fetchWithAuth";

export default function useCurriculum() {
  const [curriculum, setCurriculum] = useState(null);
  useEffect(() => {
    let live = true;
    fetchWithAuth("/api/resources/curriculum")
      .then((data) => live && setCurriculum(data?.curriculum || null))
      .catch(() => live && setCurriculum(null));
    return () => {
      live = false;
    };
  }, []);
  return curriculum;
}

/** "Zun Driving School BDE (LMS), version 2". */
export function curriculumLine(c) {
  if (!c || !c.name) return "";
  return c.version ? `${c.name}, version ${c.version}` : c.name;
}
